import { useEffect } from 'react';

// Declare gtag function for TypeScript
declare global {
  var gtag: (...args: any[]) => void;
  var dataLayer: any[];
}

const GoogleAnalytics: React.FC = () => {
  useEffect(() => {
    // Skip during pre-rendering
    if (navigator.userAgent === 'ReactSnap') return;
    
    // Wait for gtag to be available
    const checkGtag = () => {
      if (typeof globalThis.gtag === 'function') {
        // Configure additional settings
        globalThis.gtag('config', 'G-PGY3EPZFMW', {
          // Rispetta la privacy degli utenti
          anonymize_ip: true,
          // Configura il cookie consent se necessario
          cookie_flags: 'SameSite=None;Secure',
        });

        // Debug in development
        if (process.env.NODE_ENV === 'development') {
          console.log('✅ Google Analytics configured');
        }
      } else {
        // Retry after a short delay
        setTimeout(checkGtag, 100);
      }
    };

    checkGtag();
  }, []);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics;